import React from 'react';
import Type from 'prop-types';
import { observer } from 'mobx-react-lite';
import { useHistory } from 'react-router-dom';
import {
  Drawer,
  Divider,
  List,
  ListItem,
  ListItemText,
  ListItemIcon,
  ListItemAvatar,
} from '@mui/material';
import { ExitToApp as ExitToAppIcon } from "@mui/icons-material";
import { useTranslation } from 'hooks';
import { authStore } from 'stores';
import HeaderAccount from '../HeaderAccount';
import Link from '../Link';
import ExternalLink from '../ExternalLink';
import menuItems from './SideNavMenu.mock';
import styles from './SideNavMenu.module.css';

const SideNavMenu = observer((props) => {
  const { open, onClose } = props;
  const { t } = useTranslation();
  const history = useHistory();

  const handleAccountClick = () => {
    history.push('/');
  };

  const handleSignOut = () => {
    authStore.signOut();
  };

  return (
    <Drawer
      anchor="left"
      open={open}
      onClose={onClose}
      PaperProps={{
        classes: {
          root: styles.menuContainer,
        },
      }}
    >
      <div className={styles.menuList} role="presentation">
        <ListItemAvatar>
          <HeaderAccount onClick={handleAccountClick} />
        </ListItemAvatar>
        <Divider />
        <List>
          {menuItems.map((menuItem) => {
            const label = t(menuItem.label);
            const Icon = menuItem.icon;

            return (
              <ListItem
                key={menuItem.label}
                button
                component={menuItem.isExternalUrl ? ExternalLink : Link}
                to={menuItem.id}
                className={styles.menuItem}
                data-testid={menuItem.dataTestId}
              >
                <ListItemIcon>
                  <Icon />
                </ListItemIcon>
                <ListItemText
                  primary={label}
                  primaryTypographyProps={{
                    className: styles.menuItemText,
                  }}
                />
              </ListItem>
            );
          })}
        </List>
        <Divider />
        <List>
          <ListItem role={undefined} button onClick={handleSignOut}>
            <ListItemIcon>
              <ExitToAppIcon />
            </ListItemIcon>
            <ListItemText primary={t('signOut')} />
          </ListItem>
        </List>
      </div>
    </Drawer>
  );
});

SideNavMenu.propTypes = {
  open: Type.bool.isRequired,
  onClose: Type.func.isRequired,
};

export default SideNavMenu;
